/**
 * Substitute elements with default elements if they are not provided
 *
 * @template T The type of elements list
 * @param defaultElements The default elements to use
 * @param elements The elements to substitute
 * @returns The elements to use
 */export function substituteElements(// eslint-disable-next-line @typescript-eslint/no-explicit-any
defaultElements,elements){return Object.assign({},defaultElements,elements)}